import { render, staticRenderFns } from "./companyPhoto.vue?vue&type=template&id=5ad3409f&scoped=true"
import script from "./companyPhoto.vue?vue&type=script&lang=js"
export * from "./companyPhoto.vue?vue&type=script&lang=js"
import style0 from "./companyPhoto.vue?vue&type=style&index=0&id=5ad3409f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad3409f",
  null
  
)

export default component.exports